import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Image from '../components/Image'
import img1 from '../../assets/img/treninky-1.jpg'
import img2 from '../../assets/img/treninky-2.jpg'

const Treninky = () => (
  <div className="Trainings">
    <Helmet title="Muvko - Tréninky" />
    <article>
      <h1>Tréninky</h1>
      <p className="u-center"><strong>* První trénink zdarma *</strong></p>

      <div className="u-flexRow">
        <div className="u-center">
          <h2>Kdy</h2>
          <p>Úterý ♣ 20:00 - 21:30</p>
          <p>Čtvrtek ♣ 19:15 - 20:45</p>
        </div>
        <div className="u-center">
          <h2>Kde</h2>
          <address>
            Energym Fitness Club<br />
            Přívozní 937/3<br />
            Praha 7
          </address>
        </div>
      </div>
    </article>

    <div className="u-row">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2558.729815201262!2d14.449269316473641!3d50.11006397942979!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470beb4ceb21ae9d%3A0xd344b02a79eb802e!2sEnergym!5e0!3m2!1sen!2scz!4v1520820601109"
        frameBorder="0"
        style={{ border: 0, width: '100%', height: '400px' }}
        allowFullScreen
      />
    </div>

    <article>
      <p>Naše tréninky jsou zaměřené na celkový fyzický rozvoj formou hromadného cvičení a kruhového tréninku se zvolenou intenzitou a výběrem vhodných cviků pro danou skupinu cvičících. Kombinujeme funkční, silový a balanční trénink tak, aby docházelo k co nejvyššímu zvýšení Vaší vytrvalosti a dynamiky, budování funkční svalové hmoty a ztráty tělesného tuku.</p>

      <Image src={img2} alt="Energym Fitness" />

      <p>Kruhové tréninky umožňují téměř neomezené množství cvičebních variant. Dbáme na to, aby tréninky byly pestré, pokaždé jiné a nikoho tak neomrzely.</p>

      <Image src={img1} alt="Keep Muuuvin'" />
    </article>
  </div>
);

export default Treninky



// WEBPACK FOOTER //
// ./src/pages/treninky.js